import React, { useEffect, useState } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import SendIcon from '@mui/icons-material/Send';
import './MainForm.css';
import { API_URL } from '../../Constants';



function MainForm() {


    const [status, setStatus] = useState("");


    let apiUrl = API_URL;

    const handleOnClickFeasibilityForm = () => {
        let name = document.getElementById("clientName").value;
        let lastName = document.getElementById("clientLastName").value;
        let documentType = document.getElementById("clientDocumentType").value;
        let documentNumber = document.getElementById("clientDocumentNumber").value;
        let cellphone = document.getElementById("clientCellphone").value;
        let ageRange = document.getElementById("clientAgeRange").value;

        console.log(name);
        console.log(lastName);
        console.log(documentType);
        console.log(documentNumber);
        console.log(cellphone);
        console.log(ageRange);
        if (name === "" || lastName === "" || documentType === "" || documentNumber === "" || cellphone === "") {
            alert("Revisa los campos obligatorios")
        } else {
            let client = { name: name, lastName: lastName, documentType: documentType, documentNumber: documentNumber, cellphone: cellphone, ageRange: ageRange }
            createFeasibilityStudy(client)
        }
    }

    const checkResponseStatus = () => {
        window.location = '/request-status';
    }

    const createFeasibilityStudy = (client) => {
        let feasibility = { client: client, commerceUuid: localStorage.getItem('commerceUuid') }
        fetch(apiUrl + '/v1/feasibility-inquiries', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json ',
                'Accept': 'application/json',
            },
            body: JSON.stringify(feasibility),
        }).then(function (response) {
            if (response.ok) {
                response.json().then(function (res) {
                    setStatus("pending");
                    console.log(res.uuid)
                });
            }
        }).catch(function (error) {
            console.log('Hubo un problema con la petición Fetch:' + error.message);
        });
    }
    return (
        <Container fixed>
            <br />
            <br />
            <br />
            {status === "pending" ? <div>
                <h1>Por favor espere un momento... estamos procesando su solicitud</h1>
                <Button variant="contained" endIcon={<SendIcon />} onClick={checkResponseStatus}>
                    Consultar estado de la solicitud
                </Button>
            </div> :
                <Box
                    component="form"
                    sx={{
                        '& .MuiTextField-root': { m: 1, width: '25ch' },
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <form>
                        <TextField
                            required
                            id="clientName"
                            label="Name"
                            defaultValue=""
                        />
                        <br />
                        <TextField
                            required
                            id="clientLastName"
                            label="Last Name"
                            defaultValue=""
                        />
                        <br />
                        <TextField
                            required
                            id="clientDocumentType"
                            label="Document Type"
                            defaultValue=""
                        />
                        <br />
                        <TextField
                            required
                            id="clientDocumentNumber"
                            label="Document Number"
                            defaultValue=""
                        />
                        <br />
                        <TextField
                            required
                            id="clientCellphone"
                            label="Cellphone"
                            defaultValue=""
                        />
                        <br />
                        <TextField
                            id="clientAgeRange"
                            label="Age"
                            defaultValue=""
                        />
                        <br />
                        <Stack direction="row" spacing={2}>
                            <Button variant="contained" endIcon={<SendIcon />} onClick={handleOnClickFeasibilityForm} className='button'>
                                Send
                            </Button>
                            <Button variant="contained" endIcon={<SendIcon />} onClick={checkResponseStatus}>
                                Consultar estado de la solicitud
                            </Button>
                        </Stack>
                    </form>
                </Box>}
        </Container>
    );
}

export default MainForm;